/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Group_Getting_StartedInputs */



/**
* | output |
* | --- |
* | "Getting started" |
*
* @param {Onboarding_Usage_Group_Getting_StartedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_group_getting_started = /** @type {((inputs?: Onboarding_Usage_Group_Getting_StartedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Group_Getting_StartedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erste Schritte")
	return /** @type {LocalizedString} */ ("Getting started")
});